var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 7.79297V19C19.5 19.663 19.2364 20.2987 18.7676 20.7676C18.2987 21.2364 17.663 21.5 17 21.5H7C6.33696 21.5 5.70126 21.2364 5.23242 20.7676C4.76358 20.2987 4.5 19.663 4.5 19V5C4.5 4.33696 4.76358 3.70126 5.23242 3.23242C5.70126 2.76358 6.33696 2.5 7 2.5H14.207L19.5 7.79297ZM7 3.5C6.60218 3.5 6.22076 3.65815 5.93945 3.93945C5.65815 4.22076 5.5 4.60218 5.5 5V19C5.5 19.3978 5.65815 19.7792 5.93945 20.0605C6.22076 20.3419 6.60218 20.5 7 20.5H17C17.3978 20.5 17.7792 20.3419 18.0605 20.0605C18.3419 19.7792 18.5 19.3978 18.5 19V8.5H15C14.6022 8.5 14.2208 8.34185 13.9395 8.06055C13.6581 7.77924 13.5 7.39783 13.5 7V3.5H7ZM15 17.5H13V16.5H15V17.5ZM15 13.5H9V12.5H15V13.5ZM10 7.5H9V6.5H10V7.5ZM14.5 7C14.5 7.13261 14.5527 7.25975 14.6465 7.35352C14.7403 7.44728 14.8674 7.5 15 7.5H17.793L14.5 4.20703V7Z",
    fill: "#275180"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.4fd3fc51eeb2e2017a788f15df0dfc2f.svg";
export { ForwardRef as ReactComponent };